import { axiosApi } from '@/api/axios';

export default {
  markAllRead(chatIds) {
    return axiosApi.patch('/chats/messages/read_all', { chatIds });
  },
  index(projectId) {
    return axiosApi.get('/chats', { params: { projectId } });
  },
  show(chatId, params) {
    return axiosApi.get(`/chats/${chatId}/messages`, { params });
  },
  create(chatId, messageFormData) {
    return axiosApi.post(`/chats/${chatId}/messages`, messageFormData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      transformRequest: [
        (data) => data,
      ],
    });
  },
};
